import React from 'react';
import PropTypes from 'prop-types';
import { getQueryParams } from '../../utils/common';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import InViewObserver from '../InViewObserver/InViewObserver';
import analyticsWrapper from '../../helpers/analytics/analyticsWrapper';
import ElectionWidgetMainWrapper from '../ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';

const ElectionWidgetWrapper = props => {
  const { classes, styles, defaultprops, url } = props;
  const hideSharing = getQueryParams('hidesharing', { href: url });
  const hideHeading = getQueryParams('hideheading', { href: url });
  const hideLink = getQueryParams('hidelink', { href: url });
  const hideLiveblog = getQueryParams('hideliveblog', { href: url });
  const bgColor = getQueryParams('bgColor', { href: url });
  const bgColorOuter = getQueryParams('bgColorOuter', { href: url });
  const hideStarCandidate = getQueryParams('hidestarcandidate', { href: url });
  const hideETheading = getQueryParams('hideETheading', { href: url });
  const isExitPoll = getQueryParams('isExitPoll', { href: url });
  const isWapView = getQueryParams('iswapview', { href: url });
  const hideInfocus = getQueryParams('hideinfocus', { href: url });
  const exitPollRhsWidget = getQueryParams('exitpollrhswidget', { href: url });
  const preActiveState = getQueryParams('state', { href: url });
  const showDots = getQueryParams('showdots', { href: url });
  const wgtclient = getQueryParams('wgtclient', { href: url });
  const hideExitHeading = getQueryParams('hideexitheading', { href: url });
  const hidePowerStates = getQueryParams('hidepowerstates', { href: url });
  const isInnerWidget = getQueryParams('isinnerwidget', { href: url });
  const hideDisplayText = getQueryParams('hidedisplaytext', { href: url });
  const hideTitleBar = getQueryParams('hidetitlebar', { href: url });

  let ettxt = getQueryParams('ettxt', { href: url });
  ettxt = ettxt && ettxt !== '' ? decodeURI(ettxt) : '';

  const backGroundStyleOuter = bgColorOuter ? `#${bgColorOuter}` : '';
  const finalStyle = backGroundStyleOuter
    ? { backgroundColor: backGroundStyleOuter }
    : styles;

  return (
    <div style={finalStyle} className={classes}>
      <ErrorBoundary>
        <InViewObserver
          inViewCallback={() => {
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `exitpoll_widget`,
            });
          }}
        >
          <ElectionWidgetMainWrapper
            {...defaultprops}
            {...props}
            url={url}
            hideSharing={hideSharing === 'yes'}
            hideHeading={hideHeading === 'yes'}
            hideLink={hideLink === 'yes'}
            hideLiveblog={hideLiveblog === 'yes'}
            hideStarCandidate={hideStarCandidate === 'yes'}
            isExitPoll={isExitPoll === 'yes'}
            isWapView={isWapView === 'yes'}
            hideInfocus={hideInfocus === 'yes'}
            exitPollRhsWidget={exitPollRhsWidget === 'yes'}
            hideETheading={hideETheading === 'yes'}
            preActiveState={preActiveState}
            bgColor={bgColor}
            bgColorOuter={bgColorOuter}
            wgtclient={wgtclient}
            hideExitHeading={hideExitHeading === 'yes'}
            showDots={showDots === 'yes'}
            ettxt={ettxt}
            isIframeCssRequired
            tabs={props.tabs}
            // electionwdtWap={isWapView === 'yes'}
            hidePowerStates={hidePowerStates === 'yes'}
            isInnerWidget={isInnerWidget === 'yes'}
            hideDisplayText={hideDisplayText === 'yes'}
            hideTitleBar={hideTitleBar === 'yes'}
            page="iframe"
          />
        </InViewObserver>
      </ErrorBoundary>
    </div>
  );
};

ElectionWidgetWrapper.propTypes = {
  defaultprops: PropTypes.shape({}).isRequired,
  url: PropTypes.string.isRequired,
  classes: PropTypes.string,
  styles: PropTypes.string,
};

ElectionWidgetWrapper.defaultProps = {
  classes: '',
  styles: '',
};

export default ElectionWidgetWrapper;
